import { LocalSettings } from "../LocalSettings";

export type DisplayDensity = "compact" | "comfortable";

export class RegistersSettings {
  private static readonly MODULE = "registers";

  static getDisplayDensity(): DisplayDensity {
    return LocalSettings.loadSetting(this.MODULE, "displayDensity", "compact");
  }

  static setDisplayDensity(density: DisplayDensity): void {
    LocalSettings.saveSetting(this.MODULE, "displayDensity", density);
  }
}
